<template>
  <CSidebar :hideOnMobileClick="false" :show.sync="show" id="sidebar">
    <!-- <CSidebarBrand
      :imgFull="{
        alt: 'Logo',
        src: 'https://stg-event-api.dosetech.co/Media/Logo/Logo.png',
        class: 'logo-container',
      }"
    /> -->

    <img :src="`${logoImage}`" class="logo-container" />
    <CRenderFunction flat :content-to-render="nav" />
  </CSidebar>
</template>

<script>
import navBar from "./_nav";

export default {
  name: "TheSidebar",
  components: {},

  computed: {
    logoImage() {
      return this.$store.state.theme.Logo;
    },
    permission() {
      return this.$store.state.permission.Permission;
    },
  },
  data() {
    return {
      minimize: false,
      nav: JSON.parse(JSON.stringify(navBar)),
      show: "responsive",
      theme: {},
      ishavePermission: [],
      routeMeta: {},
      imageLogo: "",

      newNav: [],
      dataPermission: [],
    };
  },

  created() {
    this.userDetail();
    this.handleResize();

    setTimeout(async () => {
      this.handleActiveMenuChild(this.$route.meta);
    }, 650);
  },

  watch: {
    "$route.meta"(newValue, oldValue) {
      if (newValue.activeUrl != oldValue.activeUrl && window.innerWidth < 768) {
        this.show = false;

        document.body.style.setProperty("--margin-spacing", "0");
      }

      this.handleActiveMenu(newValue, oldValue);
    },
  },

  beforeMount() {
    window.addEventListener("resize", this.handleResize);
    if (window.innerWidth > 991)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted: async function () {
    this.$root.$on("toggle-sidebar", (val) => {
      const sidebarOpened = this.show === true || this.show === "responsive";
      this.show = sidebarOpened ? false : "responsive";
      if (!this.show) {
        document.body.style.setProperty("--margin-spacing", "0");
      } else {
        document.body.style.setProperty("--margin-spacing", "256px");
      }
    });
    this.$root.$on("toggle-sidebar-mobile", () => {
      const sidebarClosed = this.show === "responsive" || this.show === false;
      this.show = sidebarClosed ? true : "responsive";
      if (this.show == "responsive") {
        document.body.style.setProperty("--hide-text", "inline-block");
        document.body.style.setProperty("--margin-spacing", "0");
      } else if (window.innerWidth > 500) {
        document.body.style.setProperty("--hide-text", "none");
        document.body.style.setProperty("--margin-spacing", "256px");
      }
    });
    this.getPermissionList();
    const ele = document.getElementsByClassName(
      "c-sidebar-nav-dropdown-toggle"
    );
  },

  methods: {
    async userDetail() {
      this.dataPermission = this.permission;
      let finalNav = [];

      for (let i = 0; i < this.nav[0]._children.length; i++) {
        const x = this.nav[0]._children[i];

        for (let j = 0; j < this.permission.length; j++) {
          const y = this.permission[j].permissionMenuId;
          if (x.id == y) {
            finalNav.push(x);
            break;
          }
        }
      }

      this.nav[0]._children = JSON.parse(JSON.stringify(finalNav));

      const level = this.$route.meta.lv;

      const findRoute = this.dataPermission.some((x) => {
        return x.permissionMenuId == level;
      });

      if (!findRoute) {
        this.$router.push(this.nav[0]?._children[0]?.to);
      }

  
    },
    handleResize() {
      const screenSize = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      if (window.innerWidth <= 991) {
        if (window.innerWidth < 500) {
          document.body.style.setProperty("--hide-text", "none");
        }
        document.body.style.setProperty("--margin-spacing", "0");
      } else {
        document.body.style.setProperty("--hide-text", "inline-block");
        document.body.style.setProperty("--margin-spacing", "256px");
      }
      this.$store.commit("setScreenSize", screenSize);
    },
    handleActiveMenu: async function (newValue, oldValue) {
      document.body.style.setProperty("--margin-bottom", "0px");
      if (newValue.activeUrl != oldValue.activeUrl) {
        await this.handleRemoveActiveMenuChild(oldValue, newValue);
      }
      await this.handleActiveMenuChild(newValue);
    },
    handleActiveMenuChild: async function (meta) {
      this.routeMeta = meta;
      var ele = await this.getAllElementsWithAttribute(
        "a",
        "href",
        meta.activeUrl
      );
      if (meta.isChildren && ele.className == "c-sidebar-nav-link")
        await ele.setAttribute("class", "active c-sidebar-nav-link");

      var parentElement = ele;
      if (meta.lv == 1 && ele.className == "c-sidebar-nav-dropdown") {
        ele.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      } else if (meta.lv == 2) {
        parentElement =
          parentElement?.parentElement?.parentElement?.parentElement;
        if (
          parentElement &&
          parentElement.className == "c-sidebar-nav-dropdown"
        )
          parentElement.setAttribute("class", "c-sidebar-nav-dropdown c-show");
      }

      if (
        meta.lv == 3 &&
        parentElement?.parentElement?.parentElement?.className.includes(
          "c-sidebar-nav-dropdown"
        )
      ) {
        if (
          !parentElement?.parentElement?.parentElement?.className.includes(
            "c-show"
          )
        ) {
          parentElement?.parentElement?.parentElement?.setAttribute(
            "class",
            "c-sidebar-nav-dropdown-items"
          );
        }
        ele.classList.add("active");
      }
    },
    handleRemoveActiveMenuChild: async function (oldMeta, newMeta) {
      var oldEle = this.getAllElementsWithAttribute(
        "a",
        "href",
        oldMeta.activeUrl
      );
      if (!oldEle) return;

      oldEle = await this.getAllElementsWithAttribute(
        "a",
        "href",
        oldMeta.activeUrl
      );
      oldEle.classList.remove("active");
      if (oldMeta.parent != newMeta.parent) {
        let dropdown = oldEle.closest(".c-sidebar-nav-dropdown");
        if (dropdown) {
          dropdown.classList.remove("c-show");
        }
      }
    },
    getAllElementsWithAttribute(tagName, attribute, val) {
      var allElements = Array.from(document.getElementsByTagName(tagName));
      var filtered = allElements.filter((ele) => {
        return (
          ele.getAttribute(attribute) !== null &&
          ele.getAttribute(attribute) == val
        );
      });
      if (filtered.length) return filtered[0];
      else return false;
    },
    getPermissionList: async function () {
      // this.nav[0]._children = this.nav[0]._children.filter((x) => {
      //   if (x._children) {
      //     x._children = x._children.filter(
      //       (el) =>
      //         this.$store.state.permission.Permission.includes(el.id) ||
      //         el.onTest
      //     );
      //   }
      //   return this.$store.state.permission.Permission.includes(x.id);
      // });
    },
  },
};
</script>
<style lang="scss">
.h-50px {
  max-height: 50px;
}
.c-show {
  .c-sidebar-nav-dropdown-toggle {
    background: var(--primary-color) !important;
    color: var(--font-primary-color) !important;
  }
}
.logo-container {
  padding: 18px;
  max-height: 55px;
  max-width: 256px;
  width: auto;
  object-fit: contain;
  background-color: var(--theme-bar-color);
}
.c-sidebar .c-sidebar-nav-dropdown.c-show {
  // box-shadow: inset 0 0 10px 3px #d1d1d173;
  background: rgb(234 233 233 / 32%);
}
</style>
